<template>
    <div id="login">
        <div class="card card-user">
            <form @submit="login" action="#">
                <Overlay v-if="this.loading"></Overlay>
                <div class="card-body">
                    <Loading v-if="this.loading"></Loading>
                    <div class="author">
                        <div class="block block-one"></div>
                        <div class="block block-two"></div>
                        <div class="block block-three"></div>
                        <div class="block block-four"></div>
                    </div>
                    <transition
                            enter-active-class="animated fadeIn faster"
                            leave-active-class="animated fadeOut faster"
                    >
                        <div class="alert alert-danger-outline" v-if="isErrored">{{ errorMessage }}</div>
                    </transition>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Username</label>
                                <input required type="text" v-model="username" autocomplete="username" class="form-control" placeholder="Username">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Password</label>
                                <input required type="password" autocomplete="current-password" v-model="password" class="form-control" placeholder="Password">
                            </div>
                        </div>
                    </div>

                </div>
                <div class="card-footer">
                    <button type="submit" class="btn btn-fill btn-success">Login</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import ApiService from "../common/api.service";
import Loading from "./Loading";
import Overlay from "./Overlay";

export default {
    name: 'login',
    data(){
        return {
            username: '',
            password: '',
            isErrored: false,
            errorMessage: '',
            loading: false
        }
    },
    components: {
        Loading,
        Overlay
    },
    props: [],
    methods: {
        login(e){
            this.isErrored = false;
            this.loading = true;
            let that = this;
            let data = {
                nick: this.username,
                password: this.password
            };
            axios.post(ApiService.getAction('user', 'login'), data)
                .then((response) => {
                    that.isErrored = false;
                    if(response.data.status == 1){
                        this.$root.login(response.data);
                    } else {
                        that.isErrored = true;
                        that.errorMessage = response.data.message;
                    }
                })
                .finally(() => this.loading = false);
            e.preventDefault();
        }
    }
}
</script>
